import { BaseFieldProps } from '@foxtrotplatform/developer-platform-common-ui-component-lib';
import { OrganizationType } from '@foxtrotplatform/platform-micro-site-core';

import { DeveloperOrganization } from '../../../common/providers/types';

export type EmailVerificationStatus = '' | 'VERIFIED' | 'UNVERIFIED';

export interface CheckOrganizationProps {
  visible: boolean;
}

export interface EmailFieldProps extends BaseFieldProps<OrganizationCreate> {
  email: string;
  isUserEmailBusinessDomain: boolean;
  showCompanyDomainAlert: boolean;
}

export interface OrganizationCreate extends DeveloperOrganization {
  marketingPromotions: boolean;
}

export const defaultOrganizationValues: OrganizationCreate = {
  id: '',
  type: OrganizationType.individual,
  email: '',
  companyName: '',
  firstName: '',
  lastName: '',
  website: '',
  domain: '',
  country: '',
  marketingPromotions: false,
};

export const PERSONAL_EMAIL_DOMAINS = [
  'gmail.com',
  'yahoo.com',
  'hotmail.com',
  'outlook.com',
  'aol.com',
  'icloud.com',
];
